export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/NextIcon.cbf5bded.svg","height":16,"width":19,"blurWidth":0,"blurHeight":0};